import React from 'react';

interface OptimizedImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
  sizes?: string;
  width?: number;
  height?: number;
}

const OptimizedImage: React.FC<OptimizedImageProps> = ({
  src,
  alt,
  className = '',
  loading = 'lazy',
  fetchPriority = 'auto',
  sizes,
  width,
  height,
}) => {
  if (!src) {
    return (
      <div
        className={`bg-base-300 rounded-lg flex items-center justify-center ${className}`}
      >
        <span className="text-neutral/75">No Image</span>
      </div>
    );
  }

  // All images are WebP from the backend now
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      fetchPriority={fetchPriority}
      width={width}
      height={height}
      sizes={sizes}
    />
  );
};

export default OptimizedImage;
